import { render } from "./Navbar.vue?vue&type=template&id=8aa74dba&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=8aa74dba&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4100794178/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa74dba"]])

export default __exports__